import AGSHighlightWins from "ags/states/ags-highlight-wins";
import wrapperImplementation from "gameiom/wrapper/wrapper-implementation";
import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import { Services } from "slotworks/services/services";

export default class AGSFreespinsTriggeredHighlightWins extends AGSHighlightWins {

    public onEnter() {
        const totalWin = Services.currency.format(GameState.getCurrentGame().getTotalWin());

        const message = Services.translations.get("fot.gam", { credits: totalWin });

        Components.footer.showCustomMessage(message);

        super.onEnter();
    }

    public complete() {
        const win = GameState.getCurrentGame().getTotalWin();
        wrapperImplementation.onResume.addOnce(() => super.complete());
        gameWrapper.balancesUpdate(
            GameState.getCurrentGame().realBalance,
            GameState.getCurrentGame().freeBalance
        );
        gameWrapper.winningsUpdate(win);
        gameWrapper.enableFeatureMode();
        gameWrapper.setIdle();
    }
}
